import { useMutation } from '@tanstack/react-query';
import { MatchType } from 'src/types/domain.types';
import { api } from '../api-client.config';
import { toast } from 'react-toastify';
import { useGetMatchesQuery } from '../matches/getMatches';

const updateMatch = async (data: MatchType) =>
  api.put(`/matches/${data.match_id}`, data);

export const useUpdateMatchMutation = () => {
  const { refetch } = useGetMatchesQuery();

  return useMutation({
    mutationKey: ['matches'],
    mutationFn: updateMatch,
    onSuccess: () => {
      toast.success('Match updated successfully');
      refetch();
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
